export const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	backgroundColor: 'white',
	boxShadow: 24,
	p: 4,
	display: 'flex',
	flexDirection: 'column',
	outline: 'none',
	borderRadius: '16px',
	minHeight: '100px',
	minWidth: '500px',
}

export const titleStyle = {
	marginBottom: '24px',
	fontSize: '22px',
	fontWeight: 'bold',
}

export const messageStyle = {
	marginBottom: '24px',
	fontSize: '14px',
}
